import { setCookie, getCookie } from "Functions/cookie";

function toggleEditableElements(showElements) {
    const editElements = document.querySelectorAll(".js-admin-edit");

    if (editElements) {
        for (const editElement of editElements) {
            if (showElements) {
                const adminUrl = editElement.dataset.url;
                let editLink = document.createElement("a");
                let editIcon = document.createElement("i");

                editLink.className = "c-admin-edit";
                editLink.href = adminUrl;
                editLink.target = "_blank";
                editLink.innerHTML = "edit";

                // editIcon.className = 'ico ico-edit';
                // editLink.appendChild(editIcon);

                // if adminUrl contains 'boxes'
                if (adminUrl.indexOf("boxes") !== -1) {
                    editIcon.className = "ico ico-package";
                    editLink.prepend(editIcon);
                }

                // if adminUrl contains 'text-groups' or 'configuration-groups'
                if (
                    adminUrl.indexOf("text-groups") !== -1 ||
                    adminUrl.indexOf("configuration-groups") !== -1
                ) {
                    editIcon.className = "ico ico-edit";
                    editLink.prepend(editIcon);
                }

                editElement.appendChild(editLink);
            } else {
                const createdEditElement = editElement.querySelector(".c-admin-edit");

                if (createdEditElement) {
                    createdEditElement.remove();
                }
            }
        }
    }
}

(() => {
    let windowResizeTimer = false;

    function calculateAdminBarSize() {
        const adminBar = document.querySelector(".js-admin-bar");

        if (!adminBar) {
            return;
        }

        document.documentElement.style.setProperty(
            "--admin-bar-height",
            `${adminBar.offsetHeight}px`
        );
    }

    window.addEventListener("resize", (event) => {
        clearTimeout(windowResizeTimer);

        windowResizeTimer = setTimeout(function () {
            calculateAdminBarSize();
        }, 250);
    });

    calculateAdminBarSize();
})();

$(function () {
    const subTriggers = document.querySelectorAll(".js-admin-bar-sub-trigger");
    for (const subTrigger of subTriggers) {
        subTrigger.addEventListener("click", (event) => {
            const triggerEl = event.currentTarget;
            const targetSelector = triggerEl.dataset.target;
            const targetEl = document.querySelector(
                '.js-admin-bar-sub-target[data-target="' + targetSelector + '"]'
            );

            const level = triggerEl.dataset.level;
            const sameLevelTriggers = document.querySelectorAll(
                '.js-admin-bar-sub-trigger[data-level="' + level + '"]'
            );
            const sameLevelTargets = document.querySelectorAll(
                '.js-admin-bar-sub-target[data-level="' + level + '"]'
            );

            for (const sameLevelEl of [...sameLevelTriggers, ...sameLevelTargets]) {
                if (sameLevelEl === triggerEl || sameLevelEl === targetEl) {
                    continue;
                }

                sameLevelEl.classList.remove("is-active");
            }

            triggerEl.classList.toggle("is-active");
            targetEl.classList.toggle("is-active");
        });
    }

    // close when clicked outside
    document.addEventListener("click", (event) => {
        const clickedEl = event.target;
        const triggers = document.querySelectorAll(".js-admin-bar-sub-trigger.is-active");
        const targets = document.querySelectorAll(".js-admin-bar-sub-target.is-active");

        if (!triggers.length && !targets.length) {
            return;
        }

        for (const item of [...triggers, ...targets]) {
            if (clickedEl === item || item.contains(clickedEl)) {
                return;
            }
        }

        for (const item of [...triggers, ...targets]) {
            item.classList.remove("is-active");
        }
    });

    console.log(getCookie("showEditable"));
    toggleEditableElements(getCookie("showEditable") == "1");

    const editToggle = document.querySelector(".js-admin-bar-show-editable");

    if (editToggle) {
        editToggle.addEventListener("change", (event) => {
            const showEditable = event.currentTarget.checked;

            toggleEditableElements(showEditable);
            setCookie("showEditable", showEditable ? "1" : "0", 364);
        });
    }
});
